import React, { useRef } from 'react';
import test_1 from './media/1.png';
import test_2 from './media/2.png';
import test_3 from './media/3.png';
import test_4 from './media/4.png';
import './App.css';
function App() {
  const videoRef = useRef(null);
  return (
    <div className="App">
      <div className="App-wraper">
        <a 
          href="https://www.cgtn.com/specials/2025/the-second-golden-panda-awards.html"
          target="_blank"
        >
          <img src={test_1} className="App-logo" alt="logo" />
        </a>
        <a 
          href="https://news.cgtn.com/news/2025-08-23/The-2nd-Golden-Panda-Awards-to-present-27-awards-in-Chengdu-1G4R3Nalo3e/p.html"
          target="_blank"
        >
          <img src={test_2} className="App-logo" alt="logo" />
        </a>
         <a 
          href="https://news.cgtn.com/news/2025-09-09/Journey-with-the-Golden-Panda-A-celebration-of-cinema-1GwGMfTPNSM/p.html"
          target="_blank"
        >
          <img src={test_3} className="App-logo" alt="logo" />
        </a>
        <img src={test_4} className="App-logo" alt="logo" />
      </div>
    </div>
  );
}

export default App;
